export default __webpack_public_path__ + "static/media/exterior14.25e9bfb3.webp";